import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FilterForm from './FilterForm';
import FilterButton from './FilterButton';

export class Filter extends Component {
    renderButton() {
        const {
            classes = {},
            resource,
            children,
            showFilter,
            displayedFilters,
            filterValues,
        } = this.props;

        return (
            <FilterButton
                className={classes.button}
                resource={resource}
                filters={React.Children.toArray(children)}
                showFilter={showFilter}
                displayedFilters={displayedFilters}
                filterValues={filterValues}
            />
        );
    }

    renderForm() {
        const {
            classes = {},
            resource,
            children,
            hideFilter,
            displayedFilters,
            filterValues,
            setFilters,
            form
        } = this.props;
        return (
            <FilterForm
                className={classes.form}
                form={form}
                resource={resource}
                filters={React.Children.toArray(children)}
                hideFilter={hideFilter}
                displayedFilters={displayedFilters}
                initialValues={filterValues}
                setFilters={setFilters}
            />
        );
    }

    render() {
        return this.props.context === 'button'
            ? this.renderButton()
            : this.renderForm();
    }
}

Filter.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    context: PropTypes.oneOf(['form', 'button']),
    displayedFilters: PropTypes.object,
    filterValues: PropTypes.object,
    hideFilter: PropTypes.func,
    setFilters: PropTypes.func,
    showFilter: PropTypes.func,
    resource: PropTypes.string,
};

export default Filter;
